/** Eenmalige sluitingsdagen (Y-m-d). */
export const HOME_WIDGET_CLOSED_DATES = ['2026-05-25'];

/** Terugkerende + eenmalige sluitingsdagen — zelfde logica als legacy form.tpl isClosedDay. */
export function isClosedDate(ymd) {
  if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return false;
  if (HOME_WIDGET_CLOSED_DATES.includes(ymd)) return true;

  const parts = ymd.split('-');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  if (year === 2026 && month === 5 && day === 25) return true;
  if (month === 4 && day === 6) return true;
  if (month === 12 && (day === 24 || day === 25 || day === 26 || day === 31)) return true;
  if (month === 1 && day === 1) return true;

  return false;
}
